import { Injectable } from '@angular/core';

import { localidadesStorage } from "./data.service";
import {frotasStorage} from "../../../bens/frotas/shared/data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {FrotaNavigationService} from "../../../bens/frotas/shared/frota-navigation.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {OrdemServicoNavigationService} from "../../../manutencoes/ordens-servico/shared/ordem-servico-navigation.service";
import {OrdemServicoService} from "../../../manutencoes/ordens-servico/shared/ordem-servico.service";
import {ordensServicoStorage} from "../../../manutencoes/ordens-servico/shared/data.service";

@Injectable()
export class LocalidadeService {

  constructor(
    private _frotaNavigationService: FrotaNavigationService,
    private _frotaService: FrotasService,

    private _ordemServicoNavigationService: OrdemServicoNavigationService,
    private _ordemServicoService: OrdemServicoService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(localidadesStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(localidadesStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(localidadesStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === frotasStorage) {
        otherFormObject = this._frotaService.getSessionStorage();
        otherFormObject.localidade = Response;
        this._frotaService.setSessionStorage(otherFormObject);
      } else if (otherForm === ordensServicoStorage) {
        otherFormObject = this._ordemServicoService.getSessionStorage();
        otherFormObject.localidade = Response;
        this._ordemServicoService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(localidadesStorage);

    if (otherForm === frotasStorage) {
      otherFormObject = this._frotaService.getSessionStorage();
      var frotasRoute = otherFormObject.thisRoute;
      if (otherFormObject.id) {
        this._frotaNavigationService.goToEdit(otherFormObject.id, frotasRoute);
      } else {
        this._frotaNavigationService.goToNew(frotasRoute);
      }
    } else if (otherForm === ordensServicoStorage) {
      otherFormObject = this._ordemServicoService.getSessionStorage();
      if (otherFormObject.id) {
        this._ordemServicoNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._ordemServicoNavigationService.goToNew();
      }
    }
  }

  getTipoEstacionamento() {
    var tipo:number = 2; //na api de localidades o id do tipo estacionamento eh 2    
    return tipo;
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/localidades/shared/localidade.service.ts
 **/